<template>
    <div class=" pt-3 pl-5 pr-5 overflow-x-hidden">
        <div class="mb-2">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        <div class="row flex justify-between w-full">
            <h1 class="title">Risk - Mitigate</h1>
        </div>
        <div class="mt-5 bg-white border border-lightgrey ">
            <div class="w-full p-5 pb-0">
                <label class="controllabel" v-if="systemHead">Systems</label>
                <label class="controllabel" v-if="processHead">Process</label>
                <label class="controllabel" v-if="organizationHead">Organization</label>
                
                <div class="text-xs flex flex-wrap">
                    <div v-for="obj,index in systemsSelected" :key="index" class="mr-2 mb-2 bg-primary text-white px-2 py-1 rounded">
                        {{obj.label}}
                    </div>
                </div>
            </div>
            <div class="border-b border-solid border-lightgrey mx-5 mt-3 mb-2"></div>
            <div class="row flex justify-between items-center mx-5">
                <div class="text-base font-semibold">Mapping of Controls to Mitigate</div>
                <div class="buttonposition flex justify-end items-center gap-3">
                    <div ref="menuContainer" class="flex flex-row-reverse">
                            <button @click="toggleMenu" class="btns flex justify-center items-center"  :class="isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'">Add Control</button>
                            <ul  v-if="isMenuVisible" class="card shadow-sm z-50 absolute cursor-pointer marginTop">
                            <li class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="customPopupPopup">
                                <div class="flex" ><img src="@/assets/newControl.svg" alt="" class="mr-2"/>New Control</div>
                            </li>
                            <li class="px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="customClonePopup">
                                <div class="flex" ><img src="@/assets/controlClone.svg" alt="" class="mr-2"/> Clone Control</div>
                            </li>
                            </ul>
                    </div>
                    <button :class="sameControls ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'" @click="addToTable">Add</button>
                    <!-- <button class="filterButton flex" @click="filterOpen('box')"><img src="@/assets/filter.svg" class="filterIcon" />Filters</button> -->
                </div>
            </div>
            <div class="border-b border-solid border-lightgrey mx-5 mt-2 mb-2"></div>
           
            <div class="flex flex-col px-5" :class="{ 'pb-5': sortedData.length == 0 }">
                <div class="row rounded flex text-xs pt-2">
                    <div class="w-2/5">
                        <div class="flex" @click="sort('framework')">
                            <h2 class="header cursor-pointer">Framework</h2>
                            <div class="sort cursor-pointer" :class="className == 'framework' ? classSort : 'opacity-50'"></div>
                        </div>
                        <div class="mt-3 border border-lightgrey option rounded overflow-y-auto ">
                            <div class="p-2">
                                <input type="text" class="inputboxstyling" placeholder="Search Frameworks" />
                            </div>
                            <div class="overflow-y-auto mx-1 pt-1">
                            <div v-for="(framework, index) in controlsData" :key="index" class="rounded" ref="framework">
                                <div class="p-3 mt-1 pl-5 cursor-pointer rounded" :class="[framework == systemIndex ? 'bg-primary text-white font-bold' : 'bg-white hover:bg-lightgrey',index==0?'rounded-t':'']" @click="systemIndex = framework">
                                    <p class="text-xs">{{ framework }}</p>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-3/5">
                        <div class="flex" @click="sort('controls')">
                            <div class="flex">
                                <h2 class="header cursor-pointer">Controls</h2>
                                <div class="sort cursor-pointer" :class="className == 'controls' ? classSort : 'opacity-50'"></div>
                            </div>
                        </div>

                        <div class="w-full pt-0">
                            <div class="mt-3 border flex-col text-sm border-lightgrey option overflow-y-auto ml-1 rounded" ref="control">
                                <div class="p-2">
                                    <input type="text" class="inputboxstyling" placeholder="Search Controls" />
                                </div>
                                
                                <div v-for="(control, key, index) in sortedControlData" :key="index" class="mt-2">
                                    <div v-if="key == systemIndex">
                                        <div class="h-7 flex justify-normal items-center cursor-pointer pl-5 hover:bg-lightgrey" v-for="ctrl in control" v-bind:key="ctrl._id">
                                            <div class="flex items-center whitespace-nowrap">
                                                <input v-model="checkedChild" :value="ctrl._id" :id="ctrl._id" type="checkbox" class="checkbox" @change="chooseControls(ctrl._id)" ref="child" />
                                                <label :for="ctrl._id" class="pl-3 cursor-pointer">{{ ctrl.controlTitle }}</label>
                                            </div>
                                            <div class="h-7 w-full" @click="childSelect(ctrl._id)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="v$.checkedChild.$error" class="text-red-500">
                                <div class="error-text text-xs" v-if="v$.checkedChild.required.$invalid">Required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tableRow.length != 0" class="mb-8">
                <div class="border-b border-solid border-lightgrey mx-5 mt-3 mb-2"></div>
                <div class="row flex justify-between items-center">
                    <div class="mx-5 text-base font-semibold">Selected Controls</div>

                    <button class="mr-5 filterButton flex" @click="filterOpen('table')">
                        <img src="@/assets/filter.svg" class="filterIcon" />
                        Filters
                    </button>
                </div>
                <div class="mx-5 pb-5">
                    <newTable :tableRowData="tableRow" :headersData="headers"></newTable>
                    <div v-if="toolTipActive">
                        <tool-tip :tipText="toolTipText"></tool-tip>
                    </div>
                </div>                
            </div>
        </div>
    </div>
    <div class="fixed bottom-7 bg-white h-16 flex justify-end items-center" :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle }" v-if="tableRow.length > 0">
        <div class="buttonposition flex justify-end items-center px-5 mx-5">
            <button class="btnprimary mr-1.5" :class="existedControls ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="rollBack">Reset</button>
            <button :class="existedControls ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="saveSystemsControls">Next</button>
        </div>
    </div>
    <popup v-if="customPopup" :popUp="customPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                    <h1 v-if="customControlObject != undefined && customControlObject.classificationType == 3 " class="pl-2">{{customControlObject.controlTitle}}</h1>
                    <div v-else class="pl-2">
                        <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                        <h1 v-else>Control</h1>
                    </div>
                    <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>
            <div class="flex flex-col h-full">
                <div class="flex-1 overflow-auto">
                        <fieldset :disabled="customControlObject._id">
                        <div>
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div v-if="addpopup==true" class="row flex flex-row w-full">
                                        <div class="w-full mt-3">
                                            <label class="controllabel">Title</label>
                                            <!-- <div class="mb-3 mt-2 text-sm">{{ customControlObject.controlTitle || 'N/A'}}</div> -->
                                            <textarea 
                                                type="text-area"
                                                class="inputboxstyling mt-2"
                                                placeholder="Title"
                                                @input="v$.customControlObject.controlTitle.$touch()" 
                                                v-model.trim="customControlObject.controlTitle"
                                                :class="{
                                                    'is-invalid': v$.customControlObject.controlTitle.$error
                                                }"
                                            ></textarea>
                                            <div v-if="v$.customControlObject.controlTitle.$error" class="text-red-500">
                                                <div class="error-text" v-if="v$.customControlObject.controlTitle.required.$invalid">Required</div>
                                                <div v-else-if="v$.customControlObject.controlTitle && v$.customControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-row w-full"> 
                                        <div class="w-6/12 "  :class="{'topspace': addpopup}">
                                            <label class="controllabel text-xs">Frequency</label>
                                            <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlFrequency !== '' }" v-model="customControlObject.controlFrequency">
                                                <option value="" selected disabled hidden>Select</option>
                                                <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                            </select> -->
                                            <Select 
                                                v-model="customControlObject.controlFrequency"
                                                :options="dbFrequency"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="w-full custom-multiselect userSelect mt-2"
                                                :class="{
                                                    'is-invalid': v$.customControlObject.controlFrequency.$error,
                                                    'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '',
                                                }"
                                            />
                                            <div v-if="v$.customControlObject.controlFrequency.$error" class="text-red-500">
                                                <div class="error-text" v-if="v$.customControlObject.controlFrequency.required.$invalid">Required</div>
                                            </div> 
                                    
                                        </div>
                                        <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                            <label class="controllabel text-xs">Priority</label>
                                            <!-- <div class="mb-3 mt-2 text-sm" v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)"> -->
                                            <!-- <div v-if="customControlObject.controlPriority && typeof customControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customControlObject.controlPriority)">
                                                <div class="text-xs" :class="colorLabelText(customControlObject.controlPriority)">
                                                    {{ getProirityLabel(customControlObject.controlPriority) }}
                                                </div>
                                            </div>
                                            <div v-else>N/A</div> -->
                                            <!-- {{ dbPriority.find(item => item.value === customControlObject.controlPriority)?.key || 'N/A' }} -->
                                            <!-- </div> -->
                                            <!-- <select v-else class="mt-2" v-model="customControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''}">
                                                <option value="" selected disabled hidden>Select</option>
                                                <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                            </select> -->
                                                <Select
                                                v-model="customControlObject.controlPriority"
                                                :options="dbPriority"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="w-full custom-multiselect userSelect mt-2"
                                                :class="{
                                                    'is-invalid': v$.customControlObject.controlPriority.$error,
                                                    'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''
                                                }"
                                            />
                                            <div v-if="v$.customControlObject.controlPriority.$error" class="text-red-500">
                                                <div class="error-text" v-if="v$.customControlObject.controlPriority.required.$invalid">Required</div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="flex w-full">
                                    <div class="w-6/12" :class="{'topspace': addpopup}">
                                            <label class="controllabel">Number</label>
                                            <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.clientUniqueId ? customControlObject.clientUniqueId:customControlObject.controlNumber|| 'N/A'}}</div>
                                            <input
                                                v-else
                                                type="text"
                                                class="inputboxstyling mt-2 disiableState"
                                                v-model.trim="customControlObject.controlNumber"
                                                @input="v$.customControlObject.controlNumber.$touch()"
                                                placeholder="Number"
                                                disabled
                                            />
                                        </div>
                                    <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                                <label class="controllabel">Category</label>
                                                    <!-- <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlType || 'N/A'}}</div> -->
                                                    <!-- <input
                                                        v-else
                                                        type="text"
                                                        class="inputboxstyling"
                                                        @input="v$.customControlObject.controlType.$touch()"
                                                        
                                                        v-model.trim="customControlObject.controlType"
                                                        placeholder="Type"
                                                        :class="{
                                                            'is-invalid': v$.customControlObject.controlType.$error
                                                        }"
                                                    /> -->
                                                        <!-- <div> -->
                                                        <AutoComplete 
                                                        v-model="customControlObject.controlType"
                                                        :suggestions="filteredControlTypeOptions"
                                                        @complete="asyncFindControlType"
                                                        field="label"
                                                        :forceSelection="true"
                                                        placeholder="Category"
                                                        class="p-inputtext-sm systemsstyling w-full"
                                                        />
                                                    <!-- </div> -->
                                                <div v-if="v$.customControlObject.controlType.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.controlType && v$.customControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                        </div>
                                        
                                    </div>

                                    <div class="formcontainer flex flex-col">
                                        <div class="row flex flex-row w-full">
                                            <div class="w-6/12" :class="{'topspace': addpopup}">
                                                <label class="controllabel">Family</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlFamily || 'N/A'}}</div>
                                                <!-- <multiselect
                                                    v-else
                                                    v-model="customControlObject.controlFamily"
                                                    :options="filteredControlFamilyOptions"
                                                    :showNoOptions="false"
                                                    @search-change="asyncFindControlFamily"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    open-direction="bottom"
                                                    :hideArrow="false"
                                                    placeholder="Family"
                                                    class="custom-multiselect userSelect mt-2"
                                                >
                                                    <template v-slot:noResult>
                                                        <span class="text-xs">No Families Found</span>
                                                    </template>
                                                </multiselect> -->
                                                    <div v-else>
                                                    <AutoComplete 
                                                    v-model="customControlObject.controlFamily"
                                                    :suggestions="filteredControlFamilyOptions"
                                                    @complete="asyncFindControlFamily"
                                                    field="label"
                                                    :forceSelection="true"
                                                    placeholder="Control Family"
                                                    class="p-inputtext-sm systemsstyling w-full"
                                                    />

                                                    </div>
                                                
                                            </div>
                                            <div class="w-3/6 leftspacing" :class="{'topspace': addpopup}">
                                                <label class="controllabel">Class</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlClass || 'N/A'}}</div>
                                                <!-- <input
                                                    v-else
                                                    type="text"
                                                    class="inputboxstyling mt-2"
                                                    @input="v$.customControlObject.controlClass.$touch()"
                                                    placeholder="Class"
                                                    :class="{
                                                        'is-invalid': v$.customControlObject.controlClass.$error
                                                    }"
                                                    v-model.trim="customControlObject.controlClass"
                                                /> -->
                                                <div v-else>
                                                    <AutoComplete 
                                                    v-model="customControlObject.controlClass"
                                                    :suggestions="filteredControlClassOptions"
                                                    @complete="asyncFindControlClass"
                                                    field="label"
                                                    :forceSelection="true"
                                                    placeholder="Control Class"
                                                    class="p-inputtext-sm systemsstyling w-full"
                                                    />
                                                    </div>
                                                <div v-if="v$.customControlObject.controlClass.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.controlClass && v$.customControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                            <div class="w-full">
                                                <label class="controllabel">Description</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.Description || 'N/A'}}</div>
                                                <textarea
                                                    v-else
                                                    type="text-area"
                                                    class="inputboxstyling h-24 mt-2"
                                                    placeholder="Description"
                                                    v-model.trim="customControlObject.Description"
                                                    @input="v$.customControlObject.Description.$touch()"
                                                    :class="{
                                                        'is-invalid': v$.customControlObject.Description.$error
                                                    }"
                                                
                                                >
                                                </textarea>
                                                <div v-if="v$.customControlObject.Description.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.Description && v$.customControlObject.Description.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                            <div class="w-full">
                                                <label class="controllabel">Tasks</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                                <textarea
                                                    v-else
                                                    type="text-area"
                                                    class="inputboxstyling h-24 mt-2"
                                                    placeholder="Tasks"
                                                    v-model.trim="customControlObject.controlMaintenanceTask"
                                                    @input="v$.customControlObject.controlMaintenanceTask.$touch()"
                                                    :class="{
                                                        'is-invalid': v$.customControlObject.controlMaintenanceTask.$error
                                                    }"
                                                
                                                >
                                                </textarea>
                                                <div v-if="v$.customControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.controlMaintenanceTask && v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                            <div class="w-full">
                                                <label class="controllabel">Policies</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlPolicies || 'N/A'}}</div>
                                                <textarea
                                                    v-else
                                                    type="text-area"
                                                    class="inputboxstyling h-24 mt-2"
                                                    placeholder="Policies"
                                                    v-model.trim="customControlObject.controlPolicies"
                                                    @input="v$.customControlObject.controlPolicies.$touch()"
                                                    :class="{
                                                        'is-invalid': v$.customControlObject.controlPolicies.$error
                                                    }"
                                                
                                                >
                                                </textarea>
                                                <div v-if="v$.customControlObject.controlPolicies.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.controlPolicies && v$.customControlObject.controlPolicies.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row flex flex-row w-full " :class="{'topspace': addpopup}">
                                            <div class="w-full">
                                                <label class="controllabel">Guidance</label>
                                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlGuidance || 'N/A'}}</div>
                                                <textarea
                                                    v-else
                                                    type="text-area"
                                                    class="inputboxstyling h-24 mt-2"
                                                    placeholder="Guidance"
                                                    v-model.trim="customControlObject.controlGuidance"
                                                    @input="v$.customControlObject.controlGuidance.$touch()"
                                                    :class="{
                                                        'is-invalid': v$.customControlObject.controlGuidance.$error
                                                    }"
                                                
                                                >
                                                </textarea>
                                                <div v-if="v$.customControlObject.controlGuidance.$error" class="text-red-500">
                                                    <div v-if="v$.customControlObject.controlGuidance && v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                            <label class="controllabel">Frameworks</label>
                                            <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlOptionFrameWork || 'N/A'}}</div>
                                            
                                            <Select v-else
                                                v-model="customControlObject.controlOptionFrameWork"
                                                :options="frameWorksList"
                                                @change="getFrameworkControls(customControlObject.controlOptionFrameWork)"
                                                placeholder="Please select one"
                                                class="w-full custom-multiselect userSelect mt-2"
                                                :class="{
                                                    'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                                    'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                                }"
                                            />
                                        </div>

                                        <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                            <label class="controllabel">Controls</label>
                                            <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.frameworkControls || 'N/A'}}</div>
                                                <!-- <div v-else > -->
                                                    <!-- <AutoComplete 
                                                    v-model="customControlObject.frameworkControls"
                                                    :suggestions="frameworkControls"
                                                    @complete="asyncFrameworkControl"
                                                    field="label"
                                                    :forceSelection="true"
                                                    placeholder="System Category"
                                                    class="p-inputtext-sm systemsstyling  mt-2 custom-autocomplete"
                                                    /> -->
                                                    <div v-else>
                                                            <Select 
                                                                v-model="customControlObject.frameworkControls"
                                                                :options="frameworkControls"
                                                                optionValue="value"
                                                                optionLabel="label"
                                                                :disabled="customControlObject.controlOptionFrameWork==''"
                                                                appendTo="self"
                                                                placeholder="Please select one"
                                                                class="w-full custom-multiselect userSelect mt-2"
                                                                :class="{
                                                                    'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                                                    'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                                                }"
                                                            />
                                                    </div>
                                                </div>

                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <!-- <div  class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                            <div class="buttonposition flex justify-end items-center px-5 mx-5">
                                <button @click="onCancelAllControls()" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Reset</button>
                                <button @click="saveControlsChangeForActivity(10301)" :disabled="clickOnButton" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Active</button>
                            </div>
                        </div> -->
                        <div v-if="customPopup=true">
                        <div class="border-b border-solid border-lightgrey mx-5"></div>
                            <div v-if="!customControlObject._id" class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                                    <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button>
                                    <button class="btnprimary" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCustomControl(customControlObject)">Save</button>          
                            </div>
                        </div>
            </div>
    </popup>
     <popup v-if="clonePopup" :popUp="clonePopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1 v-if="customCloneControlObject != undefined && customCloneControlObject.classificationType == 3 " class="pl-2">{{customCloneControlObject.controlTitle}}</h1>
                <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customCloneControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Clone Control</h1>
                </div>
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
        <div class="flex flex-col h-full">
            <div class="flex-1 overflow-auto">
            <fieldset :disabled="customCloneControlObject._id">
            <div>
                <div class="statuscontainer popupbodycontainer">
                    <div class="formcontainer flex flex-col">
                        <div v-if="addpopup==true" class="row flex flex-row w-full">
                            <div class="w-full mt-3">
                                <label class="controllabel">Control Title</label>
                                <!-- <div class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlTitle || 'N/A'}}</div> -->
                                <!-- <textarea 
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Title"
                                    v-model.trim="customCloneControlObject.controlTitle"
                                   
                                ></textarea> -->
                                <!-- <div v-if="v$.customCloneControlObject.controlTitle.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlTitle.required.$invalid">Required</div>
                                    <div v-else-if="v$.customCloneControlObject.controlTitle && v$.customCloneControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                </div> -->
                                <AutoComplete 
                                    v-model="customCloneControlObject.controlTitle"
                                    :suggestions="filteredICOptions"
                                    @complete="asyncFindInternalControls"
                                    @item-select="bindOtherFields"
                                    @clear="resetCloneControlFields"
                                    @input="checkTitleCleared"
                                    optionLabel="label"
                                    optionValue="value" 
                                    field="label"  
                                    panelClass="clone-popup-panel"                                                                                             
                                    :forceSelection="true"
                                    placeholder="Control Title"
                                    class="p-inputtext-sm custom-multiselect systemsstyling w-full"
                                    :class="{ 'p-invalid': v$.customCloneControlObject.controlTitle.$error }"
                                    />
                                 <div v-if="v$.customCloneControlObject.controlTitle.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlTitle.required.$invalid">Required</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row w-full"> 
                            <div class="w-6/12 "  :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Frequency</label>
                                <div v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)" class="text-sm mt-2 mb-3">{{ dbFrequency.find((item:any) => item.value === customCloneControlObject.controlFrequency)?.key ?? 'N/A' }}</div>
                                <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customCloneControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency !== '' }" v-model="customCloneControlObject.controlFrequency">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                </select> -->
                                <Select v-else
                                    v-model="customCloneControlObject.controlFrequency"
                                    :options="dbFrequency"
                                    optionLabel="key"
                                    optionValue="value"
                                    :disabled="!customCloneControlObject.controlTitle"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customCloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency === '',
                                    }"
                                    
                                />
                                 <div v-if="v$.customCloneControlObject.controlFrequency.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlFrequency.required.$invalid">Required</div>
                                </div> 
                        
                            </div>
                            <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Priority</label>
                                <div class="mb-3 mt-2 text-sm" v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)">
                                <div v-if="customCloneControlObject.controlPriority && typeof customCloneControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customCloneControlObject.controlPriority)">
                                    <div class="text-xs" :class="colorLabelText(customCloneControlObject.controlPriority)">
                                        {{ getProirityLabel(customCloneControlObject.controlPriority) }}
                                    </div>
                                </div>
                                <div v-else>N/A</div>
                                <!-- {{ dbPriority.find(item => item.value === customCloneControlObject.controlPriority)?.key || 'N/A' }} -->
                                </div>
                                <!-- <select v-else class="mt-2" v-model="customCloneControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority !== ''}">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                </select> -->
                                    <Select
                                    v-else
                                    v-model="customCloneControlObject.controlPriority"
                                    :options="dbPriority"
                                    optionLabel="key"
                                    optionValue="value"
                                    placeholder="Please select one"
                                    :disabled="!customCloneControlObject.controlTitle"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customCloneControlObject.controlPriority.$error,
                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority === '',
                                    }"
                                   
                                />
                                <div v-if="v$.customCloneControlObject.controlPriority.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlPriority.required.$invalid">Required</div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="flex flex-row w-full">
                        <div class="w-6/12 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Number</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.clientUniqueId ? customCloneControlObject.clientUniqueId:customCloneControlObject.controlNumber|| 'N/A'}}</div>
                                <input
                                    v-else
                                    type="text"
                                    class="inputboxstyling mt-2 disiableState"
                                    v-model.trim="customCloneControlObject.controlNumber"
                                    placeholder="Number"
                                    disabled
                                />
                            </div>
                         <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                    <div>
                                    <label class="controllabel">Category</label>
                                    <div> 
                                        <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlType || 'N/A'}}</div>
                                        <!-- <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling"
                                            @input="v$.customCloneControlObject.controlType.$touch()"
                                            
                                            v-model.trim="customCloneControlObject.controlType"
                                            placeholder="Type"
                                            :class="{
                                                'is-invalid': v$.customCloneControlObject.controlType.$error
                                            }"
                                        /> -->
                                            <div v-else>
                                            <AutoComplete 
                                            v-model="customCloneControlObject.controlType"
                                            :suggestions="filteredControlTypeOptions"
                                            @complete="asyncFindControlType"
                                            field="label"
                                            :forceSelection="true"
                                            placeholder="Category"
                                            :disabled="!customCloneControlObject.controlTitle"
                                            class="p-inputtext-sm systemsstyling w-full"
                                            />
                                        </div>
                                    <div v-if="v$.customCloneControlObject.controlType.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlType && v$.customCloneControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full">
                                <div class="w-6/12" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Family</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlFamily || 'N/A'}}</div>
                                    <!-- <multiselect
                                        v-else
                                        v-model="customCloneControlObject.controlFamily"
                                        :options="filteredControlFamilyOptions"
                                        :showNoOptions="false"
                                        @search-change="asyncFindControlFamily"
                                        :multiple="false"
                                        :searchable="true"
                                        open-direction="bottom"
                                        :hideArrow="false"
                                        placeholder="Family"
                                        class="custom-multiselect userSelect mt-2"
                                    >
                                        <template v-slot:noResult>
                                            <span class="text-xs">No Families Found</span>
                                        </template>
                                    </multiselect> -->
                                        <div v-else>
                                        <AutoComplete 
                                        v-model="customCloneControlObject.controlFamily"
                                        :suggestions="filteredControlFamilyOptions"
                                        @complete="asyncFindControlFamily"
                                        field="label"
                                        :forceSelection="true"
                                        :disabled="!customCloneControlObject.controlTitle"
                                        placeholder="Control Family"
                                        class="p-inputtext-sm systemsstyling w-full"
                                        :class="{ 'p-invalid': v$.customCloneControlObject.controlFamily.$error }"
                                        />
                                         <div v-if="v$.customCloneControlObject.controlFamily.$error" class="text-red-500">
                                            <div v-if="v$.customCloneControlObject.controlFamily && v$.customCloneControlObject.controlFamily.restrictCharacters30.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                        </div>

                                        </div>
                                    
                                </div>
                                <div class="w-3/6 leftspacing" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Class</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlClass || 'N/A'}}</div>
                                    <!-- <input
                                        v-else
                                        type="text"
                                        class="inputboxstyling mt-2"
                                        @input="v$.customCloneControlObject.controlClass.$touch()"
                                        placeholder="Class"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlClass.$error
                                        }"
                                        v-model.trim="customCloneControlObject.controlClass"
                                    /> -->
                                    <div v-else>
                                        <AutoComplete 
                                        v-model="customCloneControlObject.controlClass"
                                        :suggestions="filteredControlClassOptions"
                                        @complete="asyncFindControlClass"
                                        field="label"
                                        :disabled="!customCloneControlObject.controlTitle"
                                        :forceSelection="true"
                                        placeholder="Control Class"
                                        class="p-inputtext-sm systemsstyling w-full"
                                        />
                                        </div>
                                    <div v-if="v$.customCloneControlObject.controlClass.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlClass && v$.customCloneControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Description</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.Description || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Description"
                                        v-model.trim="customCloneControlObject.Description"
                                        :disabled="!customCloneControlObject.controlTitle"
                                           :class="{
                                            'is-invalid': v$.customCloneControlObject.Description.$error,
                                            'disabled-textarea': !customCloneControlObject.controlTitle
                                        }"
                                       
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.Description.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.Description && v$.customCloneControlObject.Description.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Tasks</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Tasks"
                                        :disabled="!customCloneControlObject.controlTitle"
                                        v-model.trim="customCloneControlObject.controlMaintenanceTask"
                                        @input="v$.customCloneControlObject.controlMaintenanceTask.$touch()"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlMaintenanceTask.$error,
                                            'disabled-textarea': !customCloneControlObject.controlTitle
                                        }"
                                        
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlMaintenanceTask && v$.customCloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Policies</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlPolicies || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Policies"
                                        :disabled="!customCloneControlObject.controlTitle"
                                        v-model.trim="customCloneControlObject.controlPolicies"
                                          @input="v$.customCloneControlObject.controlPolicies.$touch()"
                                              :class="{
                                            'is-invalid': v$.customCloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !customCloneControlObject.controlTitle
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlPolicies.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlPolicies && v$.customCloneControlObject.controlPolicies.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full " :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Guidance</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlGuidance || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Guidance"
                                        :disabled="!customCloneControlObject.controlTitle"
                                        v-model.trim="customCloneControlObject.controlGuidance"
                                        @input="v$.customCloneControlObject.controlGuidance.$touch()"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !customCloneControlObject.controlTitle
                                        }"
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlGuidance.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlGuidance && v$.customCloneControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Frameworks</label>
                                <!-- {{ customCloneControlObject.controlOptionFrameWork }}--{{frameWorksList  }} -->
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlOptionFrameWork || 'N/A'}}</div>
                                
                                <Select v-else
                                    v-model="customCloneControlObject.controlOptionFrameWork"
                                    :options="frameWorksList"
                                    @change="getFrameworkControls(customCloneControlObject.controlOptionFrameWork)"
                                    placeholder="Please select one"
                                    :disabled="!customCloneControlObject.controlTitle"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                    'inputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork === '',
                                    'stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork !== ''
                                    }"
                                />
                            </div>
                            <!-- {{ frameworkControls }}--{{ customCloneControlObject.frameworkControls }} -->
                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Controls</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.frameworkControls || 'N/A'}}</div>
                                    <!-- <div v-else > -->
                                        <!-- <AutoComplete 
                                        v-model="customCloneControlObject.frameworkControls"
                                        :suggestions="frameworkControls"
                                        @complete="asyncFrameworkControl"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="System Category"
                                        class="p-inputtext-sm systemsstyling  mt-2 custom-autocomplete"
                                        /> -->
                                           <div v-else>
                                                <Select 
                                                    v-model="customCloneControlObject.frameworkControls"
                                                    :options="frameworkControls"
                                                    optionValue="value"
                                                    optionLabel="label"
                                                    :disabled="!customCloneControlObject.controlOptionFrameWork || !customCloneControlObject.controlTitle"
                                                    appendTo="self"
                                                    placeholder="Please select one"
                                                    class="w-full custom-multiselect userSelect mt-2"
                                                    :class="{
                                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork !== ''
                                                    }"
                                                />
                                        </div>
                                    </div>

                        </div>
                    </div>
                </div>
            </fieldset>
            </div>
        <!-- <div  class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                <div class="buttonposition flex justify-end items-center px-5 mx-5">
                    <button @click="onCancelAllControls()" :class="customCloneControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Reset</button>
                    <button @click="saveControlsChangeForActivity(10301)" :disabled="clickOnButton" :class="customCloneControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Active</button>
                </div>
            </div> -->
            <div v-if="clonepopup=true">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div v-if="!customCloneControlObject._id" class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <button class="btnprimary mr-1.5" :class="disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustomForCloning('cancel')">Reset</button>
                        <button class="btnprimary" :class="disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCustomControlForCloning(customCloneControlObject)">Save</button>          
                </div>
        </div>
        </div>
    </popup>
        
</template>
<style scoped>
.card2:hover {
    background: #e9e9e9;
}
:deep(.custom-multiselect .p-select-overlay) {
  width: 500px !important;
}
.topspace{
    margin-top: 12px;
}
.top-36{
    margin-top: 30px;
}
/* .widthForControlOptions{
    width:150px;
} */
.option {
    height: 200px;
}
.rotate-icon {
    transition: transform 0.6s;
    transform: rotate(180deg);
}
.multiselect-tag {
    font-size: 12px;
    font-weight: 600;
}
::-webkit-scrollbar {
    width: 2px;
}
.multiselect-tag.is-disabled {
    background-color: #059669 !important;
}
.multiselect.is-disabled {
    background-color: white !important;
}
.marginTop{
    margin-top:30px;
}
.w-40 {
    width: calc(100% - 170px);
}
.w-10 {
    width: calc(100% - 2.5rem);
}
.bottom-7{
    bottom: 12px;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { toast } from '@/main';
import { required, maxLength, minLength, email, helpers, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
import Multiselect from 'vue-multiselect';
import pagination from '@/components/pagination.vue';
import { emitter } from '@/main';
import breadCrumb from '@/components/breadCrumb.vue';
import newTable from '@/components/newTable.vue';
import { AutoComplete, Select } from 'primevue';
const restrictCharacters100 = helpers.regex(/^[\s\S]{0,100}$/);
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
const restrictCharacters30 = helpers.regex(/^.{0,30}$/);

export default defineComponent({
    data(): any {
        return {
            allControlsForSystem: [],
            controls: [],
            riskDataObj:[],
            frameWorksList:[],
            risks: [],
            customPopup:false,
            isMenuVisible: false,
            clonePopup:false,
            selectedControls: [],
            checkedChild: [],
            allInternalControls:[],
            optionsForInternalControls:[],
            filteredControlFamilyOptions:[],
            filteredControlClassOptions:[],
            filteredControlTypeOptions:[],
            filteredICOptions:[],
            dataBaseCheckedChild: [],
            filters: {},
            dummyControlObj:{},
            allFrameworkControls:[],
            entitiesSelect: [],
            allSystems:[],
            businessProcessList: [],
            framework: [],
            dummyFramework: [],
            selectedSystems: [],
            systemIndex: '',
            systemId: '',
            systems: [],
              activeControls: [],
            allActivityControls:[],
            inactiveControls: [],
            organizationHead: false,
            processHead: false,
            systemHead: false,

            pop: false,
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            styling: { left: '', bottom: '' },

            finalSystemsNControls: [],
            dataBaseFinalSystemsNControls: [],
            sameControls: false,
            existedControls: false,
            objectToBeSaved: [],

            currentPage: '',
            pageSize: '',
            dynamicPagination: '',

            frameworkSort: 'name',
            frameworkSortDir: 'asc',

            controlSort: 'name',
            controlSortDir: 'asc',

            classSort: '',
            className: '',

            toolTipActive : false,
            toolTipText : '',

            currentSort: 'name',
            currentSortDir: 'asc',
            systemsSelected:[],
            showFilters: false,
            showBox: false,
            dummyControls: [],
            objToBeModified: {},
            tableRow: [],
            headers: [ 'framework', 'title','deleteIcon' ],
            controlsData: ['Active Controls','Inactive Controls','All Controls'],
            tableRowControlIds: [],
            ControlTypeArray:[],
            controlClassArray:[],
            ControlFamilyArray:[],
            isSidebarToggle: true,
            cancelState: false,
            v$: useVuelidate(),
            riskData: {
                business: {},
                operations: {},
                legal: {},
                financial: {},
                likelihood: {}
            },
            routesArray:[],
            tasksData:[],
            dummyData:[],
            customControlObject: {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
             customCloneControlObject: {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
            dummyCustomCloneObj:{
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
        };
    },
    validations() {
        return {
            riskData: {
                business: { required },
                operations: { required },
                legal: { required },
                financial: { required },
                likelihood: { required }
            },
            customControlObject:{
                controlTitle: { required ,restrictCharacters100},
                controlFrequency: { required },
                controlPriority:{ required },
                controlClass: { restrictCharacters300 },
                // controlFamily: { restrictCharacters30 },
                Description:{restrictCharacters1000},
                controlGuidance: { restrictCharacters1000 },
                controlAuditMethodology: { restrictCharacters300 },
                controlAuditSuccessCriteria: { restrictCharacters300 },
                controlMaintenanceTask: { restrictCharacters1000 },
                controlPolicies: { restrictCharacters1000 },
                controlType: { restrictCharacters300 },
            },
            customCloneControlObject:
             {
                controlTitle: { required ,restrictCharacters100},
                controlFrequency: { required },
                controlPriority:{ required },
                controlClass: { restrictCharacters300 },
                controlFamily: { restrictCharacters300 },
                Description:{restrictCharacters1000},
                controlGuidance: { restrictCharacters1000 },
                controlMaintenanceTask: { restrictCharacters1000 },
                controlPolicies: { restrictCharacters1000 },
                controlType: { restrictCharacters300 },
            },
            checkedChild: { required }
        };
    },
    components: {
        Multiselect,
        toolTip,
        // pagination,
        breadCrumb,
        newTable,
        popup,
        Select,
        AutoComplete
    },
    async created() {
        await this.getSystems();
        await this.getBusinessProcess();
        await this.getBusinessEntities();
        if(this.$route.params.type=='system'){
            await this.getActiveControlsForSystem();
            await this.getInactiveControlsForSystem();
            await this.getAllControlsForSystem();
        }
        if(this.$route.params.type=='process'){
            await this.getActiveControlsForActivity();
            await this.getInactiveControlsForActivity();
            await this.getAllControlsForActivity();
        }
        await this.getInternalControls()
        await this.getControls();
        await this.getAllActiveControls();
        await this.getRiskDataList();
        await this.getAllTasks()
        await this.getAllInternalControls();

        if(this.$route.path.includes('risks')){
            this.routesArray = [{name:'Risks',routeName:'risks'},{name:'Risk-Mitigate',routeName:'riskMitigate'}];
        }else if(Object.keys(this.$route.query).includes('Risks')){
            this.routesArray = [{name:'Risks',routeName:'risks'},{ name:'Tier-Risks',routeName:'systemRisk', id:this.riskDataObj.mappedRisk },{name:'Risk-Mitigate',routeName:'riskMitigate'}];
        }else if(Object.keys(this.$route.query).includes('systems')){
            this.routesArray = [
                { name: 'Systems', routeName: 'systems' },
                { name: 'System-Information', routeName: 'systemInformation', id: this.systemsSelected[0].value},
                {name:'Risk-Mitigate',routeName:'riskMitigate'}
            ];
        }else if(Object.keys(this.$route.query).includes('process')){
            this.routesArray = [
                { name: 'Business Process', routeName: 'businessProcess' },
                { name: 'Process-Information', routeName: 'processInformation', id: `${ this.systemsSelected[0].value }` },
                {name:'Risk-Mitigate',routeName:'riskMitigate'}
            ];
        } else if(Object.keys(this.$route.query).includes('organization')){
            this.routesArray = [
                { name: 'Organization', routeName: 'organization' },
                { name: 'Organization-Information', routeName: 'worklogFromOrganization', id: `${ this.systemsSelected[0].value }` },
                {name:'Risk-Mitigate',routeName:'riskMitigate'}
            ];
        }
        
        await this.displayDefault();
        
    },
    mounted(){
        
        emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isSidebarToggle = isToggle;
		});

        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });

        emitter.off('forDelete');
        emitter.on('forDelete', (isData: any) => {
            let comingId = isData.entity.id;
            this.onDelete(isData.index, comingId)
            
        });
        document.addEventListener('click', this.handleClickOutside);
    },
    methods: {
        paginationUpdations(currentPage: any, pageSize: any) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        toggleMenu() {
            this.isMenuVisible = !this.isMenuVisible;
        },
        async customPopupPopup(){
            
            this.v$.$reset();
            this.customPopup = true;            
            this.addpopup=true;
            this.customControlObject = {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            // let id = uuidv4();
            // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            let w= await this.incrementAndAddCC();            
            this.customControlObject.controlNumber = w;  
            this.dummyControlObj.controlNumber=w;                      
        },
        async incrementAndAddCC() {
            const maxCCNumber = this.customControl.reduce((max: number, item: any) => {
                if (typeof item === 'string' && item.startsWith('CC-')) {
                const num = parseInt(item.split('-')[1]);
                if (!isNaN(num)) {
                    return Math.max(max, num);
                }
                }
                return max;
            }, 0);        
            const nextNumber = maxCCNumber + 1;
            const newCC = `CC-${nextNumber}`;
            return newCC;
        },
        asyncFindInternalControls(query:any) {            
            query = query.query.trim();
            if (query == '') {
                    this.filteredICOptions = [];
            } else {                
                this.filteredICOptions = this.optionsForInternalControls.filter((item:any) => 
                    item.label?.toLowerCase().includes(query.toLowerCase())
                );
                // let isNewOption = !this.optionsForInternalControls.some((item:any) => 
                //     item?.toLowerCase() === query.toLowerCase()
                // );
                // if (isNewOption && query !== '') {
                //     this.filteredICOptions.push(query);
                // }
            }
        },
        async bindOtherFields(){            
            if(this.customCloneControlObject!=undefined && this.customCloneControlObject.controlTitle!=undefined && this.customCloneControlObject.controlTitle!='' && typeof this.customCloneControlObject.controlTitle=='object'){
                let getCurrentIc = this.allInternalControls.find((control:any)=>this.customCloneControlObject.controlTitle.value==control._id);
                this.customCloneControlObject.controlFrequency = getCurrentIc.controlFrequency;
                this.customCloneControlObject.controlPriority = getCurrentIc.controlPriority;
                this.customCloneControlObject.controlClass = getCurrentIc.controlClass;
                this.customCloneControlObject.controlFamily = getCurrentIc.controlFamily;
                this.customCloneControlObject.controlGuidance = getCurrentIc.controlGuidance;
                this.customCloneControlObject.Description = getCurrentIc.Description;
                this.customCloneControlObject.controlMaintenanceTask = getCurrentIc.controlMaintenanceTask;
                this.customCloneControlObject.controlPolicies = getCurrentIc.controlPolicies;
                this.customCloneControlObject.controlType = getCurrentIc.controlType;
                if(getCurrentIc.frameworks!=undefined && getCurrentIc.frameworks.length>0) {
                this.customCloneControlObject.controlOptionFrameWork = getCurrentIc.frameworks[0].name;
                let frameworkControlsData = await this.getFrameworkControls(getCurrentIc.frameworks[0].name)
                this.customCloneControlObject.frameworkControls = getCurrentIc.frameworks[0].controls[0];
                this.dummyCustomCloneObj={...this.customCloneControlObject}

                }
            }
            else if(this.customCloneControlObject.controlTitle=='') {                 
                this.customCloneControlObject={
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
                }
                let controlId= await this.incrementAndAddCC();            
                this.customCloneControlObject.controlNumber = controlId; 
            }
        },
         async resetCloneControlFields() {
            if(this.customCloneControlObject!=undefined && this.customCloneControlObject.controlTitle!=undefined && this.customCloneControlObject.controlTitle!='' && typeof this.customCloneControlObject.controlTitle=='object'){
            this.customCloneControlObject.controlType = '';
            this.customCloneControlObject.controlFamily = '';
            this.customCloneControlObject.controlClass = '';
            this.customCloneControlObject.controlDescription = '';
            this.customCloneControlObject.controlMaintenanceTask = '';
            this.customCloneControlObject.controlPolicies = '';
            this.customCloneControlObject.controlGuidance = '';
            this.customCloneControlObject.controlFrequency = '';
            this.customCloneControlObject.controlPriority = '';
            this.customCloneControlObject.frameworkControls = '';
            this.customCloneControlObject.frameworks = [];
            }
            else if(this.customCloneControlObject.controlTitle=='') {                             
                this.customCloneControlObject={
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            let controlId= await this.incrementAndAddCC();            
            this.customCloneControlObject.controlNumber = controlId; 
            }
        },
        checkTitleCleared() {
            if (!this.customCloneControlObject.controlTitle) {
                this.resetCloneControlFields();
            }
        },
        async getAllActiveControls(){
            const result = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls`);
            this.customControl = [];
            result.data.map((r:any)=>{
                if(r.classificationType==10603) {
                    this.customControl.push(r.controlNumber)
                }
            })
        },
         async customClonePopup(){
            this.v$.$reset();
            this.clonePopup = true;
            this.addpopup=true;
            this.customCloneControlObject = {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            let controlId= await this.incrementAndAddCC();            
            this.customCloneControlObject.controlNumber = controlId;  
            this.dummyControlObj.controlNumber=controlId; 
            // // let id = uuidv4();
            // // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            // let w= await this.incrementAndAddCC();            
            // this.customControlObject.controlNumber = w;  
            // this.dummyControlObj.controlNumber=w;          
        },
        asyncFindControlType(query:any) {            
            query = query.query.trim();
            if (query == '') {                
                    this.filteredControlTypeOptions = [];
            } else {                
                this.filteredControlTypeOptions = this.ControlTypeArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlTypeArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlTypeOptions.push(query);
                }
            }
        },
        colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
        onCancelbtnCustom(prop:any){
            this.v$.$reset();
            if (prop === 'close') {
                this.addpopup=false;
                this.addControlpopup=false;
                this.controlEditPopup = false;
                this.clonePopup = false;
                this.customPopup = false;
                this.dummyCustomObj = {}
                this.controlsEditData={...this.dummyControlObj};
                this.frameworkControls=[];
                this.customCloneControlObject= {
                controlFrequency:"",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
                }
			}
            if(prop=='cancel'){
                this.frameworkControls=[];
            }
            if(prop=='activecancel'){
                this.controlsEditData ={...this.dummyControlObj}
            }
             if(prop=='deactivateclose'){
                this.deActiveControlObject={justification:'',forceUpdate:''};
                this.deActivatingPopup = false;            
            }
            if(prop=='deactivecancel'){
                // this.controlsEditData ={...this.dummyControlObj}
                this.deActiveControlObject={justification:'',forceUpdate:''};
            }
            if(this.customControlObject._id){
                this.customControlObject = {...this.dummyCustomObj}
            }else{
                Object.keys(this.customControlObject).forEach((prop) => {
                Array.isArray(this.customControlObject[prop])
                    ? (this.customControlObject[prop] = [])
                    : (this.customControlObject[prop] = "");
                });
                this.customControlObject.controlNumber = this.dummyControlObj.controlNumber
            }
            
        },
        getFrameworkControls(name:any){            
            this.frameworkControls=[];
            let array=Object.values(this.jsonArray)
            array.forEach((x:any)=>{
                x.forEach((y:any)=>{                    
                if(y.controlFrameWork == name){
                    this.frameworkControls.push({label:`${y.controlNumber}` + `--` + `${y.controlTitle }`,value:y._id});
                    this.allFrameworkControls.push(`${y.controlNumber}` + `--` + `${y.controlTitle }`);
                }
                })
            })            
		},
        async saveCustomControl(obj:any){
            this.v$.$touch()

            if(!this.v$.customControlObject.$invalid){
            let a = {...this.customControlObject}            

            a.frameworks = [
			   {
				"name":a.controlOptionFrameWork,
				"controls":[a.frameworkControls]
			   }
            ]

            a.isInternalControl = true

            delete a.controlOptionFrameWork
            delete a.frameworkControls


            let payload = [
                {
                    "controlFrameWork":"InternalControls",
                    "controlsList":[a]
                }
            ];
            this.clickOnButton=true;
            try{
                if(payload[0].controlsList[0].hasOwnProperty('controlType') && payload[0].controlsList[0].controlType ==null){
                        payload[0].controlsList[0].controlType =''
                }
                if(Object.keys(this.$route.query).includes('process')){
                    await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/activity/${this.$route.params.id}/controlset/create`,payload).then(async (res: { data: any }) => {
                    let cameIds:any = []

                    cameIds.push(res.data.insertedIds[0]);

                    if(cameIds.length > 0){
                        let result:any;
                        let newPayload = [{
                            "activityId": this.$route.params.id,
                            "controlIds":cameIds,
                            "createdBy":this.userInfo._id,
                            "createdAt":new Date()
                        }];
                        await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/controls/${this.$route.params.id}/manageActivity`,newPayload).then(async (res: { data: any }) => {
                            result = res.data;
                            toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                            
                            this.onCancelbtnCustom('close')
                            await this.getInternalControls();
                            await this.getActiveControlsForActivity();
                            // await this.getAllInternalControlsForActivity();
                            this.checkedChild.push(result);
                            this.sameControls = true;
                            this.chooseControls(result);
                          
                        })
                         await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,[result]).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
                    }
				    });
                }
                else if(Object.keys(this.$route.query).includes('systems')){
                    await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/system/${this.$route.params.id}/controlset/create`,payload).then(async (res: { data: any }) => {
                    let cameIds:any = []

                    cameIds.push(res.data.insertedIds[0]);

                    if(cameIds.length > 0){
                        let result:any;
                        let newPayload = [{
                            "systemId": this.$route.params.id,
                            "controlIds":cameIds,
                            "createdBy":this.userInfo._id,
                            "createdAt":new Date()
                        }];
                        await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/controls/${this.$route.params.id}/manageSystem`,newPayload).then(async (res: { data: any }) => {
                            result = res.data;
                            toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                            
                            this.onCancelbtnCustom('close')
                            await this.getInternalControls();
                            await this.getActiveControlsForSystem();
                            // await this.getAllInternalControlsForActivity();
                            this.checkedChild.push(result);
                            this.sameControls = true;
                            this.chooseControls(result);
                          
                        })
                         await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,[result]).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
                    }
				});
                }
                
            }catch(e:any){                
                if(e?.response?.status==403){
                    toast.error(`${e.response.data.error}`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                  });
                }
                else {
                    toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
                }
            }finally {
				this.clickOnButton = false;
			}}
        },
         async getAllInternalControls(){
            await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/internalcontrols/get`).then((res: any) => {
                let controls = res.data;
                this.allInternalControls = res.data;
                controls = res.data;
                for (var i = 0; i < controls.length; i++) {
                    this.optionsForInternalControls.push({ label:controls[i].controlTitle, value:controls[i]._id });
                }
            });
        },
        getProirityLabel(val:any){
            if (val === 'N/A') { 
                return 'N/A'; 
            } else {
                let a = this.dbPriority.find((obj: any) => obj.value == val);
                return (val && typeof val === 'number') ? a.key : 'N/A';
            }
        },
           async getInternalControls() {
			this.tabDataLoading = true
            this.totalOrgControls = [];
            try{
            let allIC = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls?frameWork=InternalControls`);
            let new1 = this.activeFrameworks;
            let new2 = allIC.data;
            if(new1!=undefined && new1.length>0 && new2!=undefined && new2.length>0){
                let activeFramework = new1.find((n:any)=>n.frameWorkName=='InternalControls' && n.isActive==true);
                if(activeFramework!=undefined){
                    new2.forEach((n1:any)=>{
                        // if(n1.classificationType==10603){
                        //     this.customControl.push(n1.controlNumber)
                        // }
                    })
                    
                }                
            }
            if(new2 && new2.length>0){                
                new2.map((control:any)=>{
                    if(control.controlType!='' && control.controlType!=null && control.controlType!=undefined&& (this.ControlTypeArray && !this.ControlTypeArray.includes(control.controlType))){
                        this.ControlTypeArray.push(control.controlType)
                    }
                    if(control.controlFamily!='' && control.controlFamily!=null && control.controlFamily!=undefined && (this.ControlFamilyArray && !this.ControlFamilyArray.includes(control.controlFamily))) {
                        this.ControlFamilyArray.push(control.controlFamily);
                    }
                    if(control.controlClass!='' && control.controlClass!=null && control.controlClass!=undefined &&(this.controlClassArray && !this.controlClassArray.includes(control.controlClass))){
                        this.controlClassArray.push(control.controlClass)
                    }
                })
            }
            }catch (e) {
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
            this.tabDataLoading = false
		// 	await this.$http
		// 		.get(`${process.env.VUE_APP_CONTROLS_API_URL}/api/org/allControls?frameWork=InternalControls`)
		// 		.then((result: { data: any }) => {
		// 			this.isLoading = true;
		// 			this.showLoader = false;
		// 			result.data.forEach((item: any) => {
		// 				if (item.isInternalControl) {
		// 					this.controlsList.push(item);
		// 				}
		// 			});
        //   this.editObject = {...this.controlObject}
		// 		})
		// 		.catch((error: any) => {
		// 			this.isLoading = false;
		// 			(this.showLoader = false),
		// 				toast.error(`Save failed with ${error}`, {
		// 					timeout: 1000,
		// 					closeOnClick: true,
		// 					closeButton: 'button',
		// 					icon: true
		// 				});
		// 		});
			//this.makeTable();
		},
        handleClickOutside(event:any) {
          const menuContainer = this.$refs.menuContainer;
          if (menuContainer && !menuContainer.contains(event.target)) {
            this.isMenuVisible = false;
          }
        },
         asyncFindControlFamily(query:any) {
            query = query.query.trim();
            if (query == '') {
                    this.filteredControlFamilyOptions = [];
            } else {
                this.filteredControlFamilyOptions = this.ControlFamilyArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlFamilyArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlFamilyOptions.push(query);
                }
            }
        },
        asyncFindControlClass(query:any) {      
            query = query.query.trim();            
            if (query == '') {
                    this.filteredControlClassOptions = [];
            } else {
                this.filteredControlClassOptions = this.controlClassArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                
                let isNewOption = !this.controlClassArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlClassOptions.push(query);
                }
            }
        },
        chooseControls() {
            if (this.finalSystemsNControls.length == 0) {
                this.selectedSystems.map((item: any) => {
                    let obj:any;
                    if(Object.keys(this.$route.query).includes('organization')){
                        obj = { org: [item], controls: this.checkedChild.sort() }
                    }else if(Object.keys(this.$route.query).includes('process')){
                        obj = { process: [item], controls: this.checkedChild.sort() }
                    }else if(Object.keys(this.$route.query).includes('systems') ){
                        obj = { systems: [item], controls: this.checkedChild.sort() }
                    }
                    this.finalSystemsNControls.push(obj);
                    
                });
            } else {
                
                this.finalSystemsNControls.map((item: any) => {

                    if(Object.keys(item).includes('orgId')){
                        item.org = [item.orgId];
                        delete item.orgId;

                    }else if(Object.keys(item).includes('processId') && !Object.keys(item).includes('process')){
                        item.process = [item.processId];
                        delete item.processId;

                    }else if(Object.keys(item).includes('systemId') && !Object.keys(item).includes('systems')){
                        item.systems = [item.systemId];
                        delete item.systemId;

                    }

                    item.controls = this.checkedChild.sort();
                    
                });
                
            }
            this.disableButtons();
        },
        clearSelectedControls() {
            this.framework.find((item: any) => {
                this.controls[item] = this.controls[item].filter((item: any) => {
                    return !this.checkedChild.includes(item._id);
                });
            });
        },

        disableButtons() {
            if(this.checkedChild.length == 0 || (_.isEqual(this.checkedChild.sort(), this.dataBaseCheckedChild.sort()) && _.isEqual(this.checkedChild.sort(), this.tableRowControlIds.sort()))){
                
                this.cancelState = false;
                this.sameControls = false
            }else{
                
                this.sameControls = true;
                this.cancelState = true;
            }            
            let disableCondition = ( this.sameControls == true && _.isEqual(this.checkedChild.sort(), this.tableRowControlIds.sort()) ) || !_.isEqual(this.tableRowControlIds.sort(), this.dataBaseCheckedChild.sort())
            
            disableCondition ? (this.existedControls = true) : (this.existedControls = false);
           
        },
        async addToTable() {
            var switchControls: any = {};

            this.dataBaseCheckedChild.length != 0 ? (switchControls = this.allControlsForSystem) : (switchControls = this.dummyControls);
            this.tableRow = [];
            this.tableRowControlIds = [];            
            
            this.framework.find((item: any) => {
                switchControls[item].map((itemOne: any) => {           
                    if (this.checkedChild.includes(itemOne._id)) {                        
                        this.tableRowControlIds.push(itemOne._id);
                        this.tableRow.push({ framework: item,  title: itemOne.controlTitle, id: itemOne._id });
                    }
                });
            });
            this.clearSelectedControls();
            this.disableButtons();

        },
         async getRiskDataList() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/root/risk/${this.$route.params.riskId}/get`).then((result: any) => {
                this.riskDataObj = result.data.find((risk:any)=>{
                    if (Object.keys(risk).includes('systemId')) {
                        return risk.systemId == this.systemsSelected[0].value
                    } else if (Object.keys(risk).includes('processId')) {
                        return risk.processId == this.systemsSelected[0].value
                    } else if ( Object.keys(risk).includes('orgId')) {
                        return risk.orgId == this.systemsSelected[0].value
                    }
                })
            });
        },
        async getSystems() {
            let entityId = '20005';
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.allSystems = result.data.map((sys: any) => {
                    return { value: sys._id, label: sys.systemName };
                });
            });
        },
        async getBusinessProcess() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
                this.businessProcessList = result.data.map((sys: any) => {
                    return { value: sys._id, label: sys.businessProcessName };
                });
            });
        },
        async getBusinessEntities(){
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any) => {
                this.entitiesSelect = result.data.map((org: any) => {
                    return { value: org._id, label: org.entityName };
                });
            })
        },
        cancelSelectionState() {
            this.finalSystemsNControls = [...this.dataBaseFinalSystemsNControls];
            this.controls = { ...this.dummyControls };
            this.checkedChild = [...this.dataBaseCheckedChild];
            this.chooseControls();
            this.addToTable();
            this.systemIndex = this.sortedFrameworkData[0];
        },
        rollBack() {
            this.tableRow = [];
            this.cancelSelectionState();
            localStorage.removeItem('MITIGATE_DATA')
        },
        async getAllTasks() {
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/tasks/getall`).then((result: any) => {
                this.tasksData = result.data;
            });
        },
        onDelete(index: any,ctrlId:any) {
            let details:any
            let presentTaskIdObj:any
            let taskStatusPresent:any

            if(this.dataBaseFinalSystemsNControls.length >0){
                details = this.dataBaseFinalSystemsNControls[0].tasks
                presentTaskIdObj = (details.find((obj:any)=>{
                        return obj.controlId == ctrlId;
                }))
                taskStatusPresent = 0;
                if(presentTaskIdObj){
                    let presentTask = this.tasksData.find((task:any)=>{return task._id == presentTaskIdObj.taskId})
                    
                    taskStatusPresent = presentTask.statusCode;
                }
            }
            
            if(presentTaskIdObj == undefined || taskStatusPresent == 10403 || this.dataBaseFinalSystemsNControls.length==0){
                var switchControls: any = {};
                this.dataBaseCheckedChild.length != 0 ? (switchControls = this.allControlsForSystem) : (switchControls = this.dummyControls);
                
                switchControls[this.tableRow[index].framework].map((item: any) => {
                    if (this.tableRow[index].id == item._id) {
                        this.checkedChild = this.checkedChild.filter((itemOne: any) => {
                            return itemOne != item._id;
                        });
                        this.controls[this.tableRow[index].framework].push(item);
                    }
                });

                this.tableRowControlIds = [...this.checkedChild];

                this.tableRow.splice(index, 1);
                this.tableRow.length == 0 ? (this.disableButtons(), (this.systemIndex = this.framework[0])) : '';
                this.chooseControls();
            }else{
                toast.error(`Respective Task is in pending`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
            }
            
        },
        toolTip(type: any, e: any, key:any, index:any, row:any) {
            if (type == 'text') {
                this.handleTextTooltip(e, key, index, row);
            }
        },
        handleTextTooltip(e: any,key:any, index:any, row:any) {
            const container = e.currentTarget.closest('.ellipsis-container');
            if (container && this.isTextOverflowed(container)) {
                this.pop = true;
                this.tipText = row[key];
                this.tipIndex = index;
                this.tipColumn = key;
                this.styling.left = e.offsetX + 38 + 'px';
                this.styling.bottom = -45 + 'px';
            } else {
                this.pop = false;
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollWidth > element.clientWidth;
        },
        doFalse() {
            this.pop = false;
        },
        childSelect(ctrl: any) {
            this.checkedChild.includes(ctrl)
                ? (this.checkedChild = this.checkedChild.filter((item: any) => {
                      return item !== ctrl;
                  }))
                : this.checkedChild.push(ctrl);
                this.chooseControls()
        },
        async updateRisk(risk: any) {
            try {
                let mappedriskId = risk.mappedRisk;
                delete risk._id;
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/root/${mappedriskId}/update`, risk).then((result: any) => {
                    toast.info(`Uploaded succesfully`, {
                        closeOnClick: true,
                        closeButton: 'button'
                    });
                });
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async saveSystemsControls() {            

            this.dataBaseFinalSystemsNControls = [...this.finalSystemsNControls];
            this.sameControls = false;
            this.existedControls = false;
            this.dataBaseCheckedChild = [...this.checkedChild];
            
            this.finalSystemsNControls.map((obj:any)=>{
                obj._id ? delete obj._id :'';
                obj.riskId ? delete obj.riskId:'';
                obj.tasks ? delete obj.tasks : ''

            })            

            let payload;
            if(this.dummyData.length == 0){
                payload = [
                        { 
                            mappedControls: this.finalSystemsNControls, 
                            action: 10405, 
                            riskId: this.$route.params.riskId, 
                            createdAt: new Date(),
                            createdBy: this.userInfo._id,
                            previousStatus: this.riskDataObj.statusCode
                        }
                    ];
            }else{
                let OldControls:any = this.dummyData[0].controls;
                let newControls:any = this.finalSystemsNControls[0].controls;
                
                let a = newControls.filter((num:any)=>{return !(OldControls.includes(num))});
                this.finalSystemsNControls[0].controls = a;
                payload = [
                    
                        { 
                            mappedControls: this.finalSystemsNControls, 
                            action: 10405, 
                            riskId: this.$route.params.riskId, 
                            createdAt: new Date(),
                            createdBy: this.userInfo._id,
                            previousStatus: this.riskDataObj.statusCode
                        }
                    ];
            }
            // console.log("payloadddddddddddddddddddddd", payload)
            localStorage.setItem('MITIGATE_DATA', JSON.stringify(payload));


            if((Object.keys(this.$route.query).includes('systems') && Object.keys(this.$route.query).includes('Risks')) || (this.$route.path.includes('/ControlsMap/risks') && Object.keys(this.$route.query).includes('systems'))){          
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'system', id:this.selectedSystems[0]}, query:{systems:true,risks:true}});
            }else if(Object.keys(this.$route.query).includes('process') && Object.keys(this.$route.query).includes('Risks')  || (this.$route.path.includes('/ControlsMap/risks') && Object.keys(this.$route.query).includes('process'))){          
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'process', id:this.selectedSystems[0]}, query:{process:true,risks:true}});
            }else if(Object.keys(this.$route.query).includes('organization') && Object.keys(this.$route.query).includes('Risks')  || (this.$route.path.includes('/ControlsMap/risks') && Object.keys(this.$route.query).includes('organization'))){          
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'organization', id:this.selectedSystems[0]}, query:{organization:true,risks:true}});
            }else if(Object.keys(this.$route.query).includes('systems')){
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'system', id:this.selectedSystems[0]}, query:{systems:true}});
            }else if(Object.keys(this.$route.query).includes('process')){
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'process', id:this.systemsSelected[0].value}, query:{process:true}});
            }else if(Object.keys(this.$route.query).includes('organization')){
                this.$router.push({ name: 'residualRisk', params:{riskId:this.$route.params.riskId, type:'organization', id:this.selectedSystems[0]}, query:{organization:true}});
            }
            
        },
        async displayDefault() {
            this.dummyData = [];
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/systemControls/mapping/getall`).then((result: any) => {
                this.dataBaseFinalSystemsNControls = JSON.parse(JSON.stringify(result.data));
                // console.log('mongoData', this.dataBaseFinalSystemsNControls);
            });

            const savedMitigateSystems:any = localStorage.getItem(this.$route.params.riskId);
            // console.log("savedMitigateSystems", savedMitigateSystems)

            if (this.dataBaseFinalSystemsNControls.length != 0) {
                // console.log("Ifffffffffff")
                this.dataBaseFinalSystemsNControls = this.dataBaseFinalSystemsNControls.filter((item: any) => {
                    if (Object.keys(this.$route.query).includes('systems') && item.riskId == this.$route.params.riskId && savedMitigateSystems.includes(item.systemId)) {
                        this.selectedSystems.push(item.systemId);
                        return true;
                    } else if (Object.keys(this.$route.query).includes('process') && item.riskId == this.$route.params.riskId && savedMitigateSystems.includes(item.processId)) {
                        this.selectedSystems.push(item.processId);
                        return true;
                    } else if (Object.keys(this.$route.query).includes('organization') && item.riskId == this.$route.params.riskId && savedMitigateSystems.includes(item.orgId)) {
                        this.selectedSystems.push(item.orgId);
                        return true;
                    }
                });

                // console.log('this.dataBaseFinalSystemsNControls',this.dataBaseFinalSystemsNControls)

                //followed
                if(this.selectedSystems.length !== 0){
                    // console.log('hjjhjhjhjhjhjh',this.dataBaseFinalSystemsNControls)
                    this.finalSystemsNControls = [...this.dataBaseFinalSystemsNControls];

                    // this.dummyData = [...this.dataBaseFinalSystemsNControls];
                    this.dataBaseFinalSystemsNControls.map((obj:any)=>{this.dummyData.push({...obj})})

                    this.dataBaseCheckedChild = this.dataBaseFinalSystemsNControls[0].controls;
                    this.checkedChild = [...this.dataBaseCheckedChild];
                    this.addToTable();
                    this.dummyControls = { ...this.controls };
                }    
                else{
                    this.selectedSystems = this.systems.map((item:any)=>{return item.value});
                }
            }
            else{
                this.selectedSystems = this.systems.map((item:any)=>{return item.value});
            }
                this.systemIndex = this.sortedFrameworkData[0];
        },
        async getControls(frameName:any) {
        const savedMitigateSystems = localStorage.getItem(this.$route.params.riskId);
            if(savedMitigateSystems){
                let localdata = JSON.parse(savedMitigateSystems)
                localdata.map((dataId:any)=>{
                    if(this.$route.query.systems == 'true'){
                        let systemFindObj = this.allSystems.find((system:any)=>{return system.value == dataId});
                        this.systemHead = true;
                        this.systemsSelected.push(systemFindObj);
                    }else if(this.$route.query.process == 'true'){
                        let businessProcessFindObj = this.businessProcessList.find((process:any)=>{return process.value == dataId});
                        this.processHead = true;
                        this.systemsSelected.push(businessProcessFindObj);
                    }else if(this.$route.query.organization == 'true'){
                        let tenantsFindObj = this.entitiesSelect.find((entity:any)=>{return entity.value == dataId});
                        this.organizationHead = true;
                        this.systemsSelected.push(tenantsFindObj);
                    }
                    
                })
            }
            this.systems = this.systemsSelected;
            await this.$http
                .get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
                .then((result: { data: any }) => {

                    let internalControls:any = [];
                    let  remainingControls:any = [];
                    let orgControls:any = [];

                    result.data.map((obj:any)=>{
                        if(Object.keys(obj).includes('clientUniqueId') && Object.keys(obj).includes('linkedControlID')){
                            if(obj.clientUniqueId != ''){
                                orgControls.push(obj);
                            }
                        }else if((Object.keys(obj).includes('INT_ONLY') && obj['INT_ONLY'] == "Y" && !Object.keys(obj).includes('clientUniqueId')) || (Object.keys(obj).includes('isInternalControl') && obj['isInternalControl'] == "true" && !Object.keys(obj).includes('clientUniqueId'))){
                            internalControls.push(obj);
                        } else{
                            remainingControls.push(obj);
                        }
                    })
                    this.isLoading = true;
                    this.columnObject = false;
                    this.rowData = result.data;
                    //  jsonArray: any = [];
                    let arr: any = [];
                    if((this.rowData != null || this.rowData != undefined) && this.rowData.length != 0){
                        this.rowData.forEach((item: any) => {
                            if (item.controlFrameWork && item.controlNumber && Object.keys(item).includes('controlFrameWork') && Object.keys(item).includes('controlNumber') && !Object.keys(item).includes('isInternalControl')) {
                            arr.push(item);
                            this.jsonArray = this.groupByFrameworks(arr);
                            }
                        });
                            let displayFrameName = '';	
                            if(this.jsonArray != undefined){
                                Object.keys(this.jsonArray).forEach((key, index) => {
                                if (frameName === index) {
                                    displayFrameName = key;
                                }
                                this.frameWorksList.push(key);
                                });
                            }
                    }

                    // this.controls = this.groupBy(remainingControls,'controlFrameWork');
                    // this.controls = {
                    //     ...this.controls,
                    //     'All Controls': this.activeControls
                    // };
                    // if(internalControls.length > 0){
                    //     this.controls['INTERNAL CONTROLS'] = internalControls;
                    // }

                    // if(orgControls.length > 0){
                    //     this.controls['ACTIVE CONTROLS'] = orgControls;
                    // }

                    this.dummyControls = {...this.controls}
                    this.allControlsForSystem = {...this.dummyControls} ;

                    // console.log('HIHIHIHIHI',this.controls)
                    this.framework = Object.keys(this.controls);
                    this.dummyFramework = [...this.framework];
                })
                .catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
        }, 
        groupByFrameworks(arr: any[]) {
			return arr.reduce((group: any, product: any) => {
				const { controlFrameWork } = product;
				group[controlFrameWork] = group[controlFrameWork] ?? [];
				group[controlFrameWork].push(product);
				return group;
			}, {});
		}, 
        async getActiveControlsForSystem() {
            let systemId = this.$route.params.id;

            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/system/${systemId}/controls/getall?active=true`
                );

                this.activeControls = result.data;

                // Merge instead of overwrite
                this.controls = {
                    ...this.controls,
                    'Active Controls': this.activeControls
                };
                this.dummyControls = {...this.controls}
                this.allControlsForSystem = {...this.dummyControls} ;
                this.framework = Object.keys(this.controls);
                this.dummyFramework = [...this.framework];

            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        async getAllControlsForSystem() {
            let systemId = this.$route.params.id;
 
            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/system/${systemId}/allControls/get`
                );
 
                const allControls = result.data;
 
                if (!this.controls) {
                    this.controls = {};
                }
 
                const updatedControls = {
                    ...this.controls,
                    'All Controls': allControls
                };
 
                this.controls = updatedControls;
 
                this.allControl = allControls;
                this.dummyControls = {...this.controls}
                this.allControlsForSystem = {...this.dummyControls} ;
                this.framework = Object.keys(this.controls);
                this.dummyFramework = [...this.framework];
 
            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        async getActiveControlsForActivity() {
            let activityId = this.$route.params.id;

            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/activity/${activityId}/controls/getall?active=true`
                );

                this.activeControls = result.data;

                // Merge instead of overwrite
                this.controls = {
                    ...this.controls,
                    'Active Controls': this.activeControls
                };

                this.dummyControls = {...this.controls}
                this.allControlsForSystem = {...this.dummyControls} ;
                this.framework = Object.keys(this.controls);
                this.dummyFramework = [...this.framework];
               
                

            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        async getInactiveControlsForSystem() {
            let systemId = this.$route.params.id;

            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/system/${systemId}/controls/getall?active=false`
                );

                this.inactiveControls = result.data;

                this.controls = {
                    ...this.controls,
                    'Inactive Controls': this.inactiveControls
                };

                this.dummyControls = {...this.controls}
                this.allControlsForSystem = {...this.dummyControls} ;
                this.framework = Object.keys(this.controls);
                this.dummyFramework = [...this.framework];

            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        async getInactiveControlsForActivity() {
            let activityId = this.$route.params.id;

            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/activity/${activityId}/controls/getall?active=false`
                );

                this.inactiveControls = result.data;

                this.controls = {
                    ...this.controls,
                    'Inactive Controls': this.inactiveControls
                };

            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        async getAllControlsForActivity() {
            let activityId = this.$route.params.id;

            try {
                const result = await this.$http.get(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/activity/${activityId}/allControls/get`
                );

                this.inactiveControls = result.data;                

                this.controls = {
                    ...this.controls,
                    'All Controls': this.inactiveControls
                };                

            } catch (e) {
                toast.error('error', { timeout: 1000 });
            }
        },
        groupBy(arr: any, keyName: any) {
            const grouped = arr.reduce((group: any, product: any) => {
                const keyValue = product[keyName];
                    group[keyValue] = group[keyValue] ?? [];
                    group[keyValue].push(product);
                
                return group;
            }, {});

            if (grouped['undefined']) {
                grouped['custom'] = grouped['undefined'];
                delete grouped['undefined'];
            }

            if (grouped['']) {
                grouped['custom'] = [...grouped['']];
                delete grouped[''];
            }

            return grouped;
        },
        filterOpen(status: any) {
            if (status == 'table') {
                this.showFilters = !this.showFilters;
                emitter.emit('visible', this.showFilters);
            } else if (status == 'box') {
                this.showBox = !this.showBox;
                if (this.showBox == false) {
                    this.filters = {};
                    this.framework = [...this.dummyFramework];
                    this.systemIndex = this.framework[0];
                }
            }
        },
        sort: function (name: any, status: any) {
            if (status == 'table') {
                this.className = name;
                if (name === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
                }
                this.currentSort = name;
                this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
            } else {
                if (name == 'framework') {
                    this.className = name;
                    if (name === this.frameworkSort) {
                        this.frameworkSortDir = this.frameworkSortDir === 'asc' ? 'desc' : 'asc';
                    }
                    this.frameworkSort = name;
                    this.classSort = this.frameworkSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
                } else if (name == 'controls') {
                    this.className = name;
                    if (name === this.controlSort) {
                        this.controlSortDir = this.controlSortDir === 'asc' ? 'desc' : 'asc';
                    }
                    this.controlSort = name;
                    this.classSort = this.controlSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
                }
            }
        },
        filteredFunction(filterColumn: any, columnName: any) {
            if (columnName == 'framework') {
                this.framework = this.dummyFramework.filter((item: any) => {
                    return item.toLowerCase().includes(filterColumn.toLowerCase());
                });
                this.framework.length > 0 ? (this.systemIndex = this.framework[0]) : (this.systemIndex = -1);
            } else if (columnName == 'controls') {
                Object.keys(this.dummyControls).forEach((item) => {
                    const filteredControls = this.dummyControls[item].filter((itemOne: any) => {
                        return itemOne.controlTitle.toLowerCase().includes(filterColumn.toLowerCase());
                    });
                    this.controls[item] = filteredControls;
                });
            }
        },
        
        async saveCustomControlForCloning(obj:any){
            this.v$.$touch();
            if(!this.v$.customCloneControlObject.$invalid){                
                if(obj.controlTitle!=undefined){
                    obj.controlId = obj.controlTitle.value
                }
                obj.controlTitle = obj.controlTitle.label;
                if(obj.systemId){
                    delete obj.systemId
                }
                if(obj.projectId){
                    delete obj.projectId
                }
                if(Object.keys(this.$route.query).includes('process')){
                    let typeId=10107;
                    obj.createdAt = new Date().toISOString();
                    obj.createdBy = this.userInfo._id;
                    // delete obj.controlTitle
                    let newPayload:any=[];
                    obj.frameworks = [
                    {
                        "name":obj.controlOptionFrameWork,
                        "controls":[obj.frameworkControls]
                    }
                    ]

                    obj.isInternalControl = true

                    delete obj.controlOptionFrameWork
                    delete obj.frameworkControls

                    try{
                        await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/type/${typeId}/${'activity'}/${this.$route.params.id}/control/clone`,obj).then(async (res: { data: any }) => {
                        let result =  res.data;
                        toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                        })
                        newPayload.push(res.data.insertedId);
                        this.customCloneControlObject.controlNumber=''
                        this.clonePopup =false;
                        this.addpopup = false;
                        await this.getInternalControls();
                        await this.getAllInternalControls();
                        await this.getAllActiveControls();
                        await this.getActiveControlsForActivity();                        
                        this.checkedChild.push(res.data.insertedId);
                        this.sameControls = true;
                        this.chooseControls(res.data.insertedId);
                    });
                    this.customCloneControlObject={...this.dummyCustomCloneObj}
                
                    await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,newPayload).then(async (res: { data: any }) => {
                                    //console.log('result',res.data); 
                    })

                    }catch(e){                        
                        toast.error(`Error`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                }
                else if(Object.keys(this.$route.query).includes('systems')){
                     let typeId=10108;
                    obj.createdAt = new Date().toISOString();
                    obj.createdBy = this.userInfo._id;
                    // delete obj.controlTitle
                    let newPayload:any=[];
                    obj.frameworks = [
                    {
                        "name":obj.controlOptionFrameWork,
                        "controls":[obj.frameworkControls]
                    }
                    ]

                    obj.isInternalControl = true

                    delete obj.controlOptionFrameWork
                    delete obj.frameworkControls

                    try{
                        await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/type/${typeId}/${'system'}/${this.$route.params.id}/control/clone`,obj).then(async (res: { data: any }) => {
                        let result =  res.data;
                        toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                        })
                        newPayload.push(res.data.insertedId);
                        this.customCloneControlObject.controlNumber=''
                        this.clonePopup =false;
                        this.addpopup = false;
                        await this.getInternalControls();
                        await this.getAllInternalControls();
                        await this.getAllActiveControls();
                        await this.getActiveControlsForSystem();                        
                        this.checkedChild.push(res.data.insertedId);
                        this.sameControls = true;
                        this.chooseControls(res.data.insertedId);
                    });
                    this.customCloneControlObject={...this.dummyCustomCloneObj}
                
                    await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,newPayload).then(async (res: { data: any }) => {
                                    //console.log('result',res.data); 
                    })
                    }catch(e){                        
                        toast.error(`Error`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                }
            }     
        },
    },
    computed: {
        ...mapGetters({ userInfo: 'userInfo','dbFrequency':'dbFrequency','dbPriority':'dbPriority' }),
        sortedData: function (): any {
            return [...this.tableRow]
                .filter((row: any) => {
                    for (const key in this.filters) {
                        const inputValue = this.filters[key];
                        if (inputValue !== '') {
                            if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                return false;
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        disableStatus: function (): any {
			let disableStatusCondition;

            if(this.customControlObject._id){
                if (JSON.stringify(this.customControlObject) == JSON.stringify(this.dummyCustomObj)) {
					disableStatusCondition = false;
				} else {
					disableStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.customControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n!=this.customControlObject.controlNumber) {
                        disableStatusCondition = true;
                    }
                }
            }

			return disableStatusCondition;
		},
          disableStatusForCloneControl: function (): any {
			let disableStatusCondition;

            if(this.customCloneControlObject._id){
                if (JSON.stringify(this.customCloneControlObject) == JSON.stringify(this.dummyCustomCloneObj)) {
					disableStatusCondition = false;
				} else {
					disableStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.customCloneControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n!=this.customCloneControlObject.controlNumber) {
                        disableStatusCondition = true;
                    }
                }
            }

			return disableStatusCondition;
		},
        sortedFrameworkData: function (): any {
            return [...this.framework].sort((a, b) => {
                let modifier = 1;
                if (this.frameworkSortDir === 'desc') modifier = -1;
                if (a < b) return -1 * modifier;
                if (a > b) return 1 * modifier;
                return 0;
            });
        },
        sortedControlData: function (): any {
            var sortedControls: any = {};            
            for (const key in this.controls) {
                if (this.controls[key]) {
                    var subArray = [...this.controls[key]];
                    subArray.sort((a, b) => {
                        const modifier = this.controlSortDir === 'desc' ? -1 : 1;
                        const ctrlNoA = a.controlTitle.toLowerCase();
                        const ctrlNoB = b.controlTitle.toLowerCase();
                        if (ctrlNoA < ctrlNoB) return -1 * modifier;
                        if (ctrlNoA > ctrlNoB) return 1 * modifier;
                        return 0;
                    });
                    sortedControls[key] = subArray;
                }
            }
            return sortedControls;
        }
    }
});
</script>